import React from "react";
import { Row, Card, CardBody, Col } from "reactstrap";
import AreaChart from "Components/ApexCharts/AreaChart";
import LineChart from "Components/ApexCharts/LineChart";
import BarChart from "Components/ApexCharts/BarChart";
import DonutChart from "Components/ApexCharts/DonutChart";
import CandleStickChart from "Components/ApexCharts/CandleStickChart";
import MixedChart from "Components/ApexCharts/MixedChart";
import RadarChart from "Components/ApexCharts/RadarChart";
import RadarMultipleSeries from "Components/ApexCharts/RadarMultipleSeries";
import RadarPolygon from "Components/ApexCharts/RadarPolygon";
import RadialBar from "Components/ApexCharts/RadialBar";
import MultiRadialBar from "Components/ApexCharts/MultiRadialBar";
import GradientBar from "Components/ApexCharts/GradientBar";
import SemiGauge from "Components/ApexCharts/SemiGauge";
import StackedGauge from "Components/ApexCharts/StackedGauge";

export default function ApexchartsPage() {
  return (
    <div>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <AreaChart />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <LineChart />
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <BarChart />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody className="text-center">
              <DonutChart />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <CandleStickChart />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <MixedChart />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <RadarChart />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <RadarMultipleSeries />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <RadarPolygon />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <RadialBar />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <MultiRadialBar />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <GradientBar />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <SemiGauge />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <StackedGauge />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
